import { render, staticRenderFns } from "./QuestionSummary.vue?vue&type=template&id=203425dd&scoped=true&"
import script from "./QuestionSummary.vue?vue&type=script&lang=ts&"
export * from "./QuestionSummary.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionSummary.vue?vue&type=style&index=0&id=203425dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203425dd",
  null
  
)

export default component.exports